module.exports = __webpack_public_path__ + "static/media/cat-sofa.f41a04fc.svg";